import type { TopicCalendarEvent } from '../../utils/topicScheduleHelpers';

interface Props {
  event: TopicCalendarEvent;
}

export default function TopicCalendarEventComponent({ event }: Props) {
  const { source, topicTitle } = event.resource;

  return (
    <div className="flex items-center gap-1.5 px-1 py-0.5 text-xs truncate">
      <span
        className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase ${
          source === 'admin'
            ? 'bg-blue-100 text-blue-700'
            : 'bg-gray-100 text-gray-500'
        }`}
      >
        {source}
      </span>
      <span className="truncate font-medium">{topicTitle}</span>
    </div>
  );
}
